module.exports = __webpack_public_path__ + "static/media/notice_blue.a69de4f0.svg";